import moment from 'moment';
import momentRandom from 'moment-random';

const dateWeeksBefore = (numberOfWeeksBefore) => {
  if (numberOfWeeksBefore === 0) {
    console.log(moment().format('DD/MM/YY'));
    return moment().format('DD/MM/YY');
  }
  const weeksToDay = numberOfWeeksBefore * 7;
  console.log(moment().subtract(weeksToDay, 'days').format('DD/MM/YY'));

  return moment().subtract(weeksToDay, 'days').format('DD/MM/YY');
};

const dateDayWeeksBefore = (numberOfWeeksBefore, daySinceBegining) => {
  if (numberOfWeeksBefore === 0) {
    return moment().format('DD/MM/YY');
  }

  const weeksToDay = numberOfWeeksBefore * 7;
  const weekBefore = moment().subtract(weeksToDay, 'days');
  console.log(weekBefore.add(daySinceBegining, 'days').format('DD/MM/YY'));
  return weekBefore.add(daySinceBegining, 'days').format('DD/MM/YY');
};

// const dataProgression = [
//   { date: '01/01/20', feedbackReceived: 1 , feedbackPending: 3},
//   { date: '02/01/20', feedbackReceived: 4, feedbackPending: 1},
//   { date: '03/01/20', feedbackReceived: 12 , feedbackPending: 6},
//   { date: '04/01/20', feedbackReceived: 9 , feedbackPending: 8},
//   { date: '05/01/20', feedbackReceived: 4 , feedbackPending: 3},
// ];

// good
const dataProgression = [
  { date: dateWeeksBefore(4), feedbackReceived: 1, feedbackPending: 3 },
  { date: dateWeeksBefore(3), feedbackReceived: 4, feedbackPending: 1 },
  { date: dateWeeksBefore(2), feedbackReceived: 12, feedbackPending: 6 },
  { date: dateWeeksBefore(1), feedbackReceived: 9, feedbackPending: 8 },
  { date: dateWeeksBefore(0), feedbackReceived: 4, feedbackPending: 3 }
];

// test
// const dataProgression = [
//   { date: dateDayWeeksBefore(4,3), feedbackReceived: 1 , feedbackPending: 3},
//   { date: dateDayWeeksBefore(4,2), feedbackReceived: 4, feedbackPending: 1},
//   { date: dateDayWeeksBefore(4,6), feedbackReceived: 12 , feedbackPending: 6},
//   { date: dateDayWeeksBefore(4,3), feedbackReceived: 9 , feedbackPending: 8},
//   { date: dateDayWeeksBefore(4,5), feedbackReceived: 4 , feedbackPending: 3},
// ];

export default dataProgression;
